import { Container } from "react-bootstrap";

function Refund() {
  return (
    <Container className="py-4 policy-page">
      <h2 className="mb-2">Refund &amp; Cancellation Policy</h2>
      <p className="text-muted small">Last updated: 27 April 2026</p>

      <p>
        Dial Tutors works hard to make sure every booking results in a satisfactory teaching
        experience. This policy sets out when payments are refundable, how refunds are
        processed, and how cancellations are handled. By using the platform you agree to the
        terms below.
      </p>

      <h5 className="mt-4">1. Wallet top-ups</h5>
      <p>
        Money you add to your Dial Tutors wallet is held on your behalf and can be used for
        bookings on the platform. A wallet top-up is fully refundable to the original payment
        method on written request, after deducting any amounts already consumed by completed
        demos, hires, or settled classes.
      </p>

      <h5 className="mt-4">2. Demo bookings</h5>
      <ul>
        <li>
          <strong>Cancelled by student before the demo time:</strong> the demo fee and the
          monthly fee on hold are released back to the student’s wallet in full.
        </li>
        <li>
          <strong>Cancelled by tutor or no-show by tutor:</strong> the student’s wallet is
          fully refunded and the booking is closed.
        </li>
        <li>
          <strong>Demo conducted but student rejects the tutor:</strong> the demo fee is paid
          out to the tutor for the time spent; the monthly fee on hold is released back to
          the student’s wallet.
        </li>
        <li>
          <strong>Student no-show after a confirmed demo slot:</strong> the demo fee is
          forfeited to the tutor; the monthly fee on hold is released back to the student.
        </li>
      </ul>

      <h5 className="mt-4">3. Hired tutors and monthly tuition</h5>
      <ul>
        <li>
          Once a tutor is hired, the monthly fee covers a defined number of classes per the
          schedule agreed between the student and the tutor.
        </li>
        <li>
          If you end a hire mid-month, you will be refunded the value of any unused classes
          on a pro-rata basis after deducting the platform commission and applicable
          gateway charges.
        </li>
        <li>
          Classes that the student cancels with less than 24 hours’ notice may be billed at
          the tutor’s discretion and are not refundable.
        </li>
      </ul>

      <h5 className="mt-4">4. Tutor registration fee</h5>
      <p>
        The one-time registration fee paid by tutors covers identity and document
        verification, profile activation, and listing services. It is non-refundable once
        your verification has commenced. If your application is rejected before verification
        starts, the registration fee is refunded in full.
      </p>

      <h5 className="mt-4">5. How to request a refund</h5>
      <ol>
        <li>
          Email <a href="mailto:support@dialtutors.in">support@dialtutors.in</a> with your
          registered email, the booking / hire ID, and the reason for the refund. You may
          also call us at <a href="tel:7448337000">7448337000</a>.
        </li>
        <li>Our team responds within 2 business days and may request supporting details.</li>
        <li>
          Approved refunds are processed back to the <strong>original payment method</strong>.
          Wallet refunds are credited immediately. Bank/UPI refunds typically reach you in
          <strong> 5–10 business days</strong>, depending on your bank and the payment
          gateway.
        </li>
        <li>
          Once initiated, you will receive an email or SMS confirmation containing the
          refund reference issued by the payment gateway.
        </li>
      </ol>

      <h5 className="mt-4">6. Non-refundable items</h5>
      <ul>
        <li>Service fees explicitly marked non-refundable at the time of payment.</li>
        <li>Classes already attended and acknowledged by the student.</li>
        <li>Any third-party gateway charges, where applicable.</li>
      </ul>

      <h5 className="mt-4">7. Disputes</h5>
      <p>
        If you disagree with a refund decision, please write to
        <a href="mailto:support@dialtutors.in"> support@dialtutors.in</a> within 7 days of
        the decision. We will reopen and review the case before issuing a final outcome.
        Unresolved disputes will be governed by the Terms and Conditions and Indian law.
      </p>

      <h5 className="mt-4">8. Contact</h5>
      <ul className="list-unstyled">
        <li><strong>Email:</strong> <a href="mailto:support@dialtutors.in">support@dialtutors.in</a></li>
        <li><strong>Phone:</strong> <a href="tel:7448337000">7448337000</a></li>
      </ul>
    </Container>
  );
}

export default Refund;
